<section id="skills" class="section-space" appRevealOnScroll>
  <div class="container-page">
    <app-section-heading [title]="i18n.t().skillsTitle" icon="layers" />

    <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      @for (category of categories; track category.id) {
        <article class="card-surface p-5">
          <div class="mb-4 flex items-center gap-2">
            <span
              class="flex h-8 w-8 items-center justify-center rounded-lg bg-brand-500/10 text-brand-400"
              aria-hidden="true"
            >
              @switch (category.icon) {
                @case ('languages') {
                  <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M17.25 6.75L21 12l-3.75 5.25M6.75 17.25L3 12l3.75-5.25M14.25 4.5l-4.5 15" />
                  </svg>
                }
                @case ('frontend') {
                  <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25A2.25 2.25 0 015.25 3h13.5A2.25 2.25 0 0121 5.25z" />
                  </svg>
                }
                @case ('backend') {
                  <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5.25 6.75h13.5v3H5.25v-3zm0 7.5h13.5v3H5.25v-3z" />
                  </svg>
                }
                @case ('database') {
                  <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 6.75c0 1.657 3.358 3 7.5 3s7.5-1.343 7.5-3-3.358-3-7.5-3-7.5 1.343-7.5 3zm0 5.25c0 1.657 3.358 3 7.5 3s7.5-1.343 7.5-3M4.5 17.25c0 1.657 3.358 3 7.5 3s7.5-1.343 7.5-3" />
                  </svg>
                }
                @case ('devops') {
                  <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M3 15.75l9-12 3.75 6L21 8.25 12 20.25 8.25 14.25 3 15.75z" />
                  </svg>
                }
                @case ('tools') {
                  <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.42 15.17l-4.66 4.66a2.12 2.12 0 01-3-3l4.66-4.66M15 8.25a3.75 3.75 0 10-5.3 5.3L15 8.25z" />
                  </svg>
                }
              }
            </span>
            <h3 class="text-sm font-semibold text-ink-100">
              {{ i18n.t().skillCategories[category.id] }}
            </h3>
          </div>

          <div class="flex flex-wrap gap-2">
            @for (item of category.items; track item) {
              <app-technology-badge [label]="item" [featured]="isFeatured(item)" />
            }
          </div>
        </article>
      }
    </div>
  </div>
</section>
